import { render } from "./charge.vue?vue&type=template&id=d9009bd8&scoped=true"
import script from "./charge.vue?vue&type=script&lang=js"
export * from "./charge.vue?vue&type=script&lang=js"

import "./charge.vue?vue&type=style&index=0&id=d9009bd8&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9009bd8"]])

export default __exports__